<template>
  <div id="nandouliuxingyanshoudeng">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>南斗六星延寿灯</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">南斗六星延寿灯</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="
                    require('@/assets/img/products/nan-dou-liu-xing-yan-shou-deng.jpg')
                  "
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『南斗六星延寿灯』</h5>

                <p class="project-description">
                  北斗七星雖然古今中外都有名，大多數人只知道北斗
                  七星，卻不知道有南斗六星，南斗星君，南極大帝，南極仙翁
                  ,三者名異實同，南斗星位在南方，為六星組成，似斗，故名
                  南斗，職司祿壽，掌管壽命南斗六星。這六顆星在那兒呢？在
                  仲夏的晚上，朝中天偏南的位置看去，也就是人馬座的方向〔
                  占星學中稱之為射手座〉，其位於天蝎座的東方。南斗六星掌
                  管專命，北斗七星掌管死亡。在「三國演義」中第六十九回的
                  「卜周易管輅知機，討漢賊五臣死節」篇中有詳細描述。
                </p>

                <p class="project-description">
                  話說三國時代，有一位上通天文、下知地理，可與諸
                  葛孔明齊名的神卜家叫做管輅（輅音同路〕，一天走在田野間
                  ，看到一位少年在耕田，看了很久之後問那少年：「年輕人，
                  請問你的大名是？現在幾歲？」
                </p>

                <p class="project-description">
                  少年回答：「我叫趙顏，今年十九歲。請教先生是哪位？」
                  管輅：「我是管輅，我看你的眉間有死氣，三日內必死，你長
                  得不錯，可惜壽命不長。」
                  趙顏回家後，趕緊告訴父親。父親聽到後，立刻帶著趙顏追上
                  管輅，哭著跪拜請求解救的方法。
                  管輅說：「這是天命，怎能改變呢？」
                  趙顏父哭著求管輅：「我只有這麼一個兒子，請可憐我們、解
                  救我們吧！」趙顏也跪著哭求。
                </p>

                <p class="project-description">
                  管輅看他們父子情切，因此對趙顏說：「你可以準備
                  清酒一壺，鹿肉一盤，明天去到南山之中，會看到有一棵大樹下
                  有兩個人在下棋，一個人穿著白袍、面貌凶惡，向著南方坐；另
                  一個穿著紅袍、面貌和藹，向著北方坐。你可以趁著他們專注下
                  棋的時候，將酒和鹿肉獻上。等他們吃完後，你就哭著跪拜求壽
                  ，定能成功。但請不要說是我教你的。」
                </p>

                <p class="project-description">
                  隔天趙顔準備了酒肉杯盤向南山走去，約走了五六里
                  ，果然有兩個老人專注的在大松樹下的磐石上下棋，也沒注意到
                  趙顏的走近。趙顏跪著獻上了酒肉，由於兩位老人沉迷在下棋中
                  ，不知不覺的把酒肉吃完了。趙顏於是跪拜哭倒在地，請求兩人
                  能為他改壽，兩個老人這時才驚覺趙顏的存在。穿紅袍的老人說
                  :「這一定是管輅教你的。」然後對白袍老人說：「我們兩個人
                  既然用了別人的好處，就必須幫人家做些事。
                </p>

                <p class="project-description">
                  白袍老人於是從身邊取出一本簿子查看，向趙顏說：
                  「你今年十九歲，是該歲數終了。我現在在你歲數上多加一個九
                  ，讓你可以活到九十九歲。回去請告訴管輅，不要再洩漏天機，
                  不然必遭天譴。」
                </p>

                <p class="project-description">
                  紅袍老人拿出筆在簿子上添加了個九字後，一陣香氣
                  飄過，兩人化作白鶴向天空飛去。趙顔回去後詢問管輅，管輅說
                  :「穿紅衣的是南斗老人，穿白衣的是北斗老人，丨南斗注生，
                  北斗注死。』」從此管輅擔心洩露天機，因此不再輕易為人算命。
                </p>

                <p class="project-description">
                  <span><b>※怎麼情況適合點南斗六星燈陣? </b></span>
                </p>

                <p class="project-description">
                  南斗六星掌人生，注寿赐福。《星经》云：南斗六星，主天子寿命，也主宰相爵禄之位。逢年過節，生日大壽、身體不適、心情煩悶、欠佳、多病、善忘、憂鬱者需點南斗六星燈陣。（如果懷孕媽媽能為胎兒常點燃南斗六星燈陣，除了能順利生產外，還可以添福增壽）
                  點南斗六星燈陣之前，需先洗手後才點。點燃南斗六星燈陣時，只要先點燃三支香，然後才點燃南斗六星燈，然後將南斗六星燈陣放在大門前預先擺好的桌子，向着要正大門外。
                  南斗六星燈火熄滅後，將南斗六星燈紙盒拿去焚化時，最好能同時焚燒還債金，讓南斗星君也替你還債！如果家中不方便，可到寺廟去點燃，或委托寺廟中人去點燃。
                  記住南斗六星燈點燃，需唸： 心香一炷仰叩鴻恩
                  善信口口口誠心敬備南斗六星燈陣恭請南斗星君降來本
                  家受善信虔誠奉敬叩求神光普照、增加壽元、长年益壽、
                  鎮宅光明、祈合家平安、身體健康、諸事如意。 神靈顯赫家安泰
                  無災無禍福常來 上聞 恭此
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="nan-dou-liu-xing-yan-shou-deng" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "NanDouLiuXingYanShouDeng",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/NanDouLiuXingYanShouDeng.vue